// extracted by mini-css-extract-plugin
export default {"cuisine":"Cuisine_cuisine__8yytc","filter":"Cuisine_filter__rpct4"};